import dynamic from 'next/dynamic'

import { Loading } from '../../../../../loading'

export const ProductPagePrescriptionTypeSelectionModalDesktopContent = dynamic(
  async () =>
    import('./ProductPagePrescriptionTypeSelectionModalDesktopContent.tsx').then(
      (mod) => mod.ProductPagePrescriptionTypeSelectionModalDesktopContent,
    ),
  {
    loading: () => <Loading />,
    ssr: false,
  },
)
